import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import toolbarStickyHOC from './toolbarStickyHOC';
import ContextsSwitcher from '../ContextsSwitcher';
import ResultToolbarBottomLeftControls from './ResultToolbarBottomLeftControls';
import ResultToolbarBottomRightControls from './ResultToolbarBottomRightControls';
import SortBy from '../SortBy';

import './ResultToolbarDefaultView.scss';

export function ResultToolbarDefaultView(props) {
  const { stickyInfo, refOnToolbar, filtersOpened, doesZoomHovered, refOnTopSection, children } = props;
  const { isSticky } = stickyInfo;
  const openedFiltersWithSticky = isSticky && filtersOpened;

  return (
    <header
      ref={refOnToolbar}
      id="main-content"
      className={classnames('result-toolbar rx-left-gutter rx-right-gutter sticky-toolbar', {
        'result-toolbar-zoom-hovered': doesZoomHovered,
        'result-toolbar-sticky-with-opened-filters': openedFiltersWithSticky,
      })}>
      {children}
      <section ref={refOnTopSection} className="context-section-toolbar u-els-margin-top-1o2">
        <ContextsSwitcher {...props} />
        <SortBy {...props} />
      </section>
      <section className="result-toolbar-bottom-section">
        <ResultToolbarBottomLeftControls {...props} />
        <ResultToolbarBottomRightControls {...props} />
      </section>
    </header>
  );
}

ResultToolbarDefaultView.propTypes = {
  stickyInfo: PropTypes.object.isRequired,
  refOnToolbar: PropTypes.object.isRequired,
  filtersOpened: PropTypes.bool,
  doesZoomHovered: PropTypes.bool.isRequired,
  refOnTopSection: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default toolbarStickyHOC(ResultToolbarDefaultView);
